<template>
  <div>
    <v-text-field v-model="bottomBarData.phoneNumber" :label="'Phone number'" persistent-placeholder></v-text-field>
    <v-text-field
      class="d-none"
      v-model="bottomBarData.phoneNumberAppendText"
      :label="'Phone number append text'"
      persistent-placeholder></v-text-field>
  </div>
</template>

<script>
  export default {
    name: "BottomBarDialog",
    data() {
      return {
        bottomBarData: {
          phoneNumber: "",
          // For now, the input is hidden and the value is hardcoded.
          phoneNumberAppendText: "(TTY 711)",
        },
      };
    },
    watch: {
      bottomBarData: {
        handler(newValue) {
          this.updateValue(newValue);
        },
        deep: true,
      },
    },
    beforeMount() {
      this.setupReceiveDataListener();
      this.requestData();
    },
    methods: {
      updateValue(val) {
        const data = btoa(unescape(encodeURIComponent(JSON.stringify(val))));

        window.parent.postMessage(
          {
            mceAction: "updateBottomBarData",
            data: data,
          },
          origin,
        );
      },
      setupReceiveDataListener() {
        window.onmessage = message => {
          if (message.data.type === "sendData") {
            const { data } = message.data;
            this.bottomBarData = JSON.parse(decodeURIComponent(escape(window.atob(data))));
          }
        };
      },
      requestData() {
        window.parent.postMessage(
          {
            mceAction: "requestData",
          },
          origin,
        );
      },
    },
  };
</script>

<style lang="scss" scoped></style>
